<template>
  <!--
      	作者：luoyiming
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-编辑活动-其它
      -->
  <div>
    <div class="common-form">礼品卡设置</div>

    <el-form-item label="使用次数">
      <el-input v-model="form.usage_count" type="number" min="0" step="1" placeholder="请输入数量"></el-input>
    </el-form-item>

    <Product :form="form" :type="type"></Product>

  </div>
</template>

<script>
import Product from './Product'
export default {
  components: {
    Product,
  },
  props: ['form', 'type']
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/part/Pickup.vue